import { Injectable } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { environment } from 'src/environments/environment';
import * as Stomp from 'stompjs';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  stompClient: any;
  connected = false;

  constructor() {
  }

  connect() {
    const socket = new SockJS(environment.wsURL);
    const connectPromise = new Promise<void>((resolve, reject) => {
      this.stompClient = Stomp.over(socket);
      this.stompClient.debug = null;
      this.stompClient.connect({}, (frame) => {
        this.connected = true;
        console.warn('%c handshake succeeded ', 'background: red; color: yellow');
        resolve();
      }, () => {
        this.connected = false;
      });
    });
    return connectPromise;
  }

  disconnect() {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
    }
  }
}
